import { AbstractChartOptionsModel } from './abstract-chart-options.model';
import { ChartMetadataModel } from './chart-metadata.model';
import { ChartModel } from './chart.model';

export class ChartGroupInputModel {
    charts: ChartModel[];
    options?: AbstractChartOptionsModel;
    metadata?: ChartMetadataModel;

    constructor(charts: ChartModel[], options?: AbstractChartOptionsModel, metadata?: ChartMetadataModel) {
        this.charts = charts;
        this.options = options;
        this.metadata = metadata;
    }

    clone(): ChartGroupInputModel {
        return new ChartGroupInputModel(
            this.charts.map(chart => chart.clone ? chart.clone() : chart),
            this.options,
            this.metadata
        );
    };
}
